import React from 'react'
import { connect } from 'react-redux'
import {
  showPopupDialog,
  showPopupSuccessSnackbar,
  showPopupErrorSnackbar,
} from 'support/popup_dialogs'
import ErrorSubmitModal from './components/dialogs/ErrorSubmitContainer'

import { getScorecardTemplatelist , cloneScoreCardTemplate} from 'services/innovate/templates'
import View from './View'



const mapStateToProps = state => ({
  myEmail: state.data.user.userEmail,
  listScorecardTemplateLoading: state.data.templates.listScorecardTemplateLoading,
  listScorecardTemplate:state.data.templates.listScorecardTemplate,
  
})

const mapDispatchToProps = dispatch => {
  return {
    getScorecardTemplatelistFn: ()=>{
      dispatch(getScorecardTemplatelist())
    },
    getCloneScorecardTemplateFn: (cloneScorecardParams, onSuccessCallback) => {

      const onSuccess = (data) => {
        const message = 'Template clone has been completed.';
        
        dispatch(getScorecardTemplatelist())
        showPopupSuccessSnackbar(message, dispatch);
        
        // ✅ trigger component callback
        onSuccessCallback?.(data);
      };
    
      const onFailure = ({ data }) => {
        const messageTag =
          data && data.error
            ? `${data.error.desc}`
            : 'BACKEND_ERRORS.UNEXPECTED';
    
        showPopupDialog(
          <ErrorSubmitModal description={messageTag} />,
          dispatch
        );
      };
    
      dispatch(cloneScoreCardTemplate(cloneScorecardParams, onSuccess, onFailure));
    }
    
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
